var React = require('react');

function StairsDownInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M60 60H4","fill":"#FFE0E0","opacity":".654","key":0}),React.createElement("path",{"d":"M0 0h64v64H0z","key":1}),React.createElement("path",{"stroke":"currentColor","strokeWidth":"2","strokeLinecap":"square","d":"M59 59V47H46V35H32V23H19V11H5","key":2}),React.createElement("path",{"d":"M51 21L41 11","stroke":"currentColor","strokeWidth":"2","strokeLinejoin":"round","key":3}),React.createElement("path",{"stroke":"currentColor","strokeWidth":"2","strokeLinecap":"square","strokeLinejoin":"round","d":"M43 21h8v-8","key":4})]));
}

StairsDownInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = StairsDownInline;

StairsDownInline.default = StairsDownInline;
